<template>
  <div>
    <ValidationObserver ref="observer" v-slot="{ passes }">
      <div class="contents">
        <b-form @submit.prevent="passes(onSubmit)">
          <div class="row g-0 table-type header-col">
            <div class="col-sm-4">
              <span class="required">{{ $t("title.common.country") }}</span>
            </div>
            <div class="col-sm-8">
              <select
                v-model="form.countryno"
                required
                @change="change_country"
                class="form-select-lg"
              >
                <option value="0" disabled>
                  {{ $t("title.common.country") }}
                </option>
                <option
                  :value="val.countryno"
                  v-for="(val, index) in countrylist"
                  :key="index + 's'"
                >
                  {{ val.countryname }}
                </option>
              </select>
            </div>

            <div class="col-sm-4">
              <span class="required">{{ $t("title.membership.state") }}</span>
            </div>
            <div class="col-sm-8">
              <select v-model="form.statesno" required class="form-select-lg">
                <option value="" disabled>
                  {{ $t("title.membership.state") }}
                </option>
                <option
                  :value="states.statesno"
                  v-for="(states, index) in stateslist"
                  :key="index + 's'"
                >
                  {{ states.statesdesc }}
                </option>
              </select>
            </div>

            <div class="col-sm-4">
              <span class="required">{{
                $t("title.membership.time_zone")
              }}</span>
            </div>
            <div class="col-sm-8">
              <select v-model="form.timezone" required class="form-select-lg">
                <option value="0" disabled>
                  {{ $t("title.membership.time_zone") }}
                </option>
                <option
                  v-for="(val, index) in timezonelist"
                  :value="val.timezonelist_pk"
                  :key="index + 't'"
                >
                  {{ val.timezonelist_name }} (UTC
                  {{
                    val.timezonelist_offset >= 0
                      ? "+" + val.timezonelist_offset
                      : val.timezonelist_offset
                  }}:00)
                </option>
              </select>
            </div>
          </div>

          <div class="btn-bottom-wrapper">
            <b-button
              size="xl"
              variant="outline-primary"
              :aria-label="$t('button.common.list')"
              @click="$router.push({ name: 'TimezoneList' })"
              >{{ $t("button.common.list") }}</b-button
            >
            <b-button
              size="xl"
              variant="primary"
              :aria-label="$t('button.common.save')"
              type="submit"
              >{{ $t("button.common.save") }}</b-button
            >
          </div>
        </b-form>
      </div>
    </ValidationObserver>
  </div>
</template>

<script>
import "@/filter/common";
import options from "@/config/options";
import { ValidationObserver } from "vee-validate";
import InputWithValidation from "@/components/common/validations/inputbox";
import SelectBoxWithValidation from "@/components/common/validations/selectbox";
import ax from "@/api/manager";

export default {
  name: "TimezoneWrite",
  components: {
    ValidationObserver,
  },
  data() {
    return {
      form: {
        countryno: "0",
        statesno: "",
        timezone: 0,
      },
      timezonelist: [],
      countrylist: [],
      stateslist: [],

      partOptions: options.partOptions,
      positionOptions: options.positionOptions,
      statusOptions: options.statusOptions,
      timezone_pk: this.$route.params.timezone_pk || "",
    };
  },
  methods: {
    onSubmit() {
      // 등록
      ax.setTimezone(this.form, this.timezone_pk, (flag, data) => {
        console.log("this.form", this.form);

        if (flag) {
          alert(data.message);
          this.$router.push({ name: "TimezoneList" });
        } else {
          alert(data.message);
          return false;
        }
      });
    },
    getView() {
      ax.getTimezoneView(this.timezone_pk, (flag, data) => {
        if (flag) {
          this.form = data.timezoneinfo;
          console.log("this.form", this.form);
          if (this.form.countryno) this.get_stateslist();
        } else {
          alert(data.message);
        }
      });
    },

    get_countrylist() {
      ax.get_countrylist((flag, data) => {
        if (flag) {
          this.countrylist = data.countrylist;
        } else {
          alert(data);
        }
      });
    },

    change_country() {
      this.form.statesno = "";

      this.get_stateslist();
    },
    get_timezonelist() {
      ax.get_timezonelist((flag, data) => {
        if (flag) {
          this.timezonelist = data.timezonelist;
        } else {
          alert(data);
        }
      });
    },
    get_stateslist() {
      ax.get_stateslist(this.form.countryno, (flag, data) => {
        if (flag) {
          this.stateslist = data.stateslist;
          console.log("states_list", this.stateslist);
        } else {
          alert(data);
        }
      });
    },
  },
  created() {
    this.get_countrylist();
    this.get_timezonelist();
    if (this.timezone_pk) {
      this.getView();
    }
  },
};
</script>
